<template>
  <div>
    <b-form-group
      label="Référence colis à échanger"
      label-for="ref"
      description="Saisissez la référence logistique du colis à échanger. Utilisez le numéro du bordereau ou le code-barres."
    >
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="MaximizeIcon" />
        </b-input-group-prepend>
        <b-form-input
          id="ref"
          ref="select"
          v-model="ref"
          placeholder="Numéro du bordereau ou code-barres du colis"
          aria-label="Référence du colis à échanger"
        />
      </b-input-group>
      <small class="form-text text-muted">
        <b-icon-info-circle class="mr-1" />
        Entrez le numéro du bordereau ou scannez le code-barres du colis à échanger.
      </small>
    </b-form-group>

    <b-button
      v-ripple
      variant="primary"
      type="submit"
      class="mt-1"
      aria-label="Chercher le colis à échanger"
      @click.prevent="searchOrder"
    >
      <feather-icon
        icon="SearchIcon"
        class="mr-1"
      />
      Rechercher le colis à échanger
    </b-button>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,

  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      ref: '',
    }
  },

  mounted() {
    if (this.$refs.select) {
      this.$refs.select.focus()
    }
  },
  methods: {

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },

    async searchOrder() {
      if (!this.ref || this.ref.trim() === '') {
        this.showToast('danger', 'top-center', 'Veuillez saisir une référence de colis valide.')
        return
      }
      this.$router.push({ name: 'order-echange-show', params: { id: this.ref } })
    },

  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
